module.exports = __webpack_public_path__ + "static/media/19ESCAP11.a2bf3073.jpg";